"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
const _excluded = ["img", "href", "list"];
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const formatAdvantageCommon = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items;
  const handledItemsList = items === null || items === void 0 ? void 0 : items.map((activityItem, index) => {
    const _ref2 = activityItem || {},
      img = _ref2.img,
      _ref2$href = _ref2.href,
      href = _ref2$href === void 0 ? '' : _ref2$href,
      _ref2$list = _ref2.list,
      list = _ref2$list === void 0 ? [] : _ref2$list,
      other = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
    const btnExtendProps = {
      'report-event': 'click_Solution_item',
      'report-ext1': title || '',
      'report-ext2': href || ''
    };
    const handledList = list === null || list === void 0 ? void 0 : list.map(item => item.text);
    return _objectSpread(_objectSpread({}, other), {}, {
      href,
      btnExtendProps,
      list: handledList,
      img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url
    });
  });
  return {
    porintId,
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    bg,
    items: handledItemsList
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const heroData = formatAdvantageCommon(data, {
      domains
    });
    console.log(heroData);
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: heroData === null || heroData === void 0 ? void 0 : heroData.porintId,
      className: "gems-materials-qci__newUI-solution"
    }, (0, _reportUtil.reportShow)(['show_newUI_Solution', componentKey, (heroData === null || heroData === void 0 ? void 0 : heroData.title) || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      title: heroData === null || heroData === void 0 ? void 0 : heroData.title,
      bg: heroData === null || heroData === void 0 ? void 0 : heroData.bg
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.Solution, {
      items: heroData.items
    })));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}